module.exports = __webpack_public_path__ + "img/icon1.274de18d.png";